var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSchoolInYourDistrict(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.822 19.466.193.075.19-.084c.297-.131.59-.362.864-.634a8.45 8.45 0 0 0 .852-1.012c.57-.781 1.152-1.772 1.676-2.833 1.032-2.095 1.883-4.566 1.889-6.313.13-1.833-.65-3.375-1.737-4.449C14.67 3.15 13.242 2.5 12.002 2.5c-1.188 0-2.615.574-3.712 1.613a5.633 5.633 0 0 0-1.777 4.55c.005 1.74.79 4.208 1.796 6.31.51 1.063 1.087 2.057 1.672 2.842.57.763 1.202 1.405 1.841 1.651z",
    fill: "#757D99",
    stroke: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolInYourDistrict);
export default __webpack_public_path__ + "static/media/school-in-your-district.3522170204bbe4f4999ee979f21c59d3.svg";
export { ForwardRef as ReactComponent };